import { Button, Stack, Typography } from "@mui/material";
import StatusChip from "./StatusChip";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import React from "react";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { useNavigate } from "react-router-dom";
import { useUserInfoQuery } from "../../../api/userApiSlice";


const GeneralBlockButtons = (props: any) => {

    const navigate = useNavigate();
    const { data: userData, refetch } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducData = ducDataObject?.GENERAL?.[ducDataObject?.GENERAL.length - 1]
    const secondDucExists = ducDataObject?.GENERAL.length === 2

    const DucNotExpiredAndNotExpiring: boolean = !props.expired && !props.expiring
    const DucExpiringNotExpired: boolean = props.expiring && !props.expired
    const notSubApplicant: boolean = !ducDataObject?.subApplicantGeneral && ducDataObject?.subApplicantGeneral !== undefined
    const DucInProgressNotSignedByOfficial: boolean = (ducData?.status === "InProgress" || ducData?.status === "Submitted") && !ducData?.dateSignedOfficial
    const DucInProgress: boolean = ducData?.status !== "NotSubmitted" && ducData?.status !== "Approved" && ducData?.status !== "Declined"
    const DucApprovedTrainingNotComplete: boolean = ducData?.status === "Approved" && ducDataObject?.ducStatus !== "TrainingComplete"
    const DucApprovedTrainingComplete: boolean = ducData?.status === "Approved" && ducDataObject?.ducStatus === "TrainingComplete"
    const DucApprovedOrDeclinedTrainingComplete: boolean = (ducData?.status === "Approved" || ducData?.status === "Declined") && ducDataObject?.ducStatus === "TrainingComplete"
    const DucNotDeclinedOrSecondDucDoesExists: boolean = ducData?.status !== 'Declined' || secondDucExists

    const setOldStatus = () => {
        localStorage.setItem('status', ducData?.status)
    }

    const handleClickGen = () => {
        setOldStatus()
        localStorage.setItem('edit', "false")
        localStorage.setItem('formType', "GENERAL")
        localStorage.setItem('AddSub', "false")

        if(ducData?.status === 'NotSubmitted' || ducData?.status === 'Declined'){
            props.setOpen(true)
        }
        else{
            navigate("/duc/request");
        }
    }

    const handleClickGenView = () => {
        setOldStatus()
        localStorage.setItem('edit', "false")
        localStorage.setItem('formType', "GENERAL")
        localStorage.setItem('AddSub', "false")

        navigate("/duc/request");
    }

    const handleClickEdit = () => {
        setOldStatus()
        localStorage.setItem('formType', "GENERAL")
        if(ducData?.group){
            localStorage.setItem('isGroup', "true")
        }
        else{
            localStorage.setItem('isGroup', "false")
        }
        localStorage.setItem('AddSub', "false")
        localStorage.setItem('edit', "true")
        navigate("/duc/request");
    }

    const handleClickTrain = () => {

        refetch().then(() => {
            // Ensure the status is updated in localStorage before navigating
            if (ducData?.status) {
                localStorage.setItem('status', ducData.status);
            }
            navigate("/duc/training");
        })
    };

    const handleClickViewSub = () => {
        setOldStatus()
        navigate("/duc/sub-applicants")
    }

    const handelCLickAddSub = () => {
        setOldStatus()
        localStorage.setItem('formType', "GENERAL")
        localStorage.setItem('AddSub', "true")
        localStorage.setItem('edit', "true")
        localStorage.setItem('isGroup', "true")
        navigate("/duc/request")
    }

    const handleClickDelete = () => {
        setOldStatus()
        props.setCancelRefresh(!props.cancelRefresh)
        props.setOpenDeleteModal(true);
    }

    return (
        <Stack
            flexDirection="row"
            justifyContent="space-between"
            gap={3}>
            <Stack
                flexDirection="row"
                alignItems="center"
                gap={2}>
                <Typography fontSize="16px" fontWeight="600" variant="h2" id="general-use-header">
                    Data Use Certification for NIH Brain Development Cohorts
                </Typography>

                {(ducData?.status  === 'Approved') && DucNotExpiredAndNotExpiring && ducDataObject?.ducStatus !== 'Rejected' &&
                    <StatusChip
                        state="approved"/>}

                {DucExpiringNotExpired &&
                    <StatusChip
                        state='expiring'
                        time={new Date(ducData?.expiresOn).getMonth() - new Date().getMonth()}/>}

                {props.expired &&
                    <StatusChip
                        state='expired'/>}

                {ducDataObject?.ducStatus === 'Rejected' &&
                    <StatusChip
                        state='rejected'/>}

            </Stack>

            {ducData?.status === 'NotSubmitted' &&
                <Button
                    id="duc-general-request-access-button"
                    variant="primary"
                    onClick={handleClickGen}
                    sx={{ alignSelf: "center" }}
                >
                    Request access
                </Button>}

            {ducData?.status === 'Declined' && !secondDucExists &&
                <Button
                    id="duc-general-new-request-button"
                    variant="primary"
                    onClick={handleClickGen}
                    sx={{ alignSelf: "center" }}
                >
                    New Request
                </Button>}
            {ducData?.status  !== 'NotSubmitted' && DucNotDeclinedOrSecondDucDoesExists && DucNotExpiredAndNotExpiring && props.checkedCurrentStatus &&

                <Stack
                    flexDirection="row"
                    gap={4}
                    alignItems={"center"}>
                    <Button
                        id="duc-general-view-request-button"
                        variant="primary"
                        onClick={handleClickGenView}
                        sx={{ minWidth: "max-content"
                        }}
                    >
                        {(ducData?.status !== "Approved") ? "View Request": "View Certification"}
                    </Button>

                    {DucInProgressNotSignedByOfficial && notSubApplicant &&
                        <Button
                            id="duc-general-edit-request-button"
                            variant="secondary"
                            onClick={handleClickEdit}
                            sx={{ minWidth: "max-content" }}
                        >
                            Edit Request
                        </Button>

                    }

                    {DucInProgress && notSubApplicant &&
                        <Button
                            id="duc-general-cancel-button"
                            variant="outlined"
                            color="error"
                            sx={{ minWidth: "max-content" }}
                            onClick={handleClickDelete}
                        >
                            Cancel Request
                        </Button>

                    }

                    {DucApprovedTrainingNotComplete &&
                        <Button
                            id={"duc-general-start-training-button"}
                            variant="primary"
                            onClick={handleClickTrain}

                            sx={{ minWidth: "max-content" }}
                        >
                            Start Training
                        </Button>}

                    {(DucApprovedTrainingComplete || secondDucExists)  && ducData.group && notSubApplicant &&
                        <Button
                            id="duc-general-view-subapplicant-button"
                            variant="primary"
                            onClick={handleClickViewSub}

                            sx={{ minWidth: "max-content" }}
                        >
                            View Sub-applicant(s)
                        </Button>}
                    {DucApprovedOrDeclinedTrainingComplete && ducData.group && notSubApplicant &&
                        <Button
                            id="duc-general-add-subapplicant-button"
                            variant="primary"
                            startIcon={<AddBoxOutlinedIcon/>}
                            onClick={handelCLickAddSub}
                            sx={{ minWidth: "max-content" }}>
                            Add new Sub-applicant
                        </Button>}
                </Stack>}

            {(props.expiring || props.expired)  &&
                <Button
                    id="duc-general-renewal-button"
                    variant="primary"
                    onClick={handleClickGen}
                    sx={{ alignSelf: "center" }}
                >
                    Renewal
                </Button>}

        </Stack>

    )
}

export default GeneralBlockButtons
